<template #body="slotProps">
        <DataTable
            v-model:filters="filters"
            :value="tableData"
            :rows="rows"
            :paginator="true"
            :loading="isLoading"
            filterDisplay="row"
            :rowsPerPageOptions="rowsPerPageOptions"
            v-model:selection="selectedDocuments"
            lazy
            @page="onPaginate"
            :currentPage="currentPage"
            :totalRecords="totalRecords"
        >
            <template #header>
                <FormKit type="form" #default="{ state: { valid } }" :actions="false"  >
                    <div class="flex w-full">
                        
                  
                        <div class="  justify-start mr-auto" >
                            <div class="grid grid-cols-1 gap-1">
                                <div class="col">
                                <FormKit
                                    type="datepicker"
                                    name="availabilityStartDate"
                                    label="Date de début"
                                    validation="checkDatesIntervalRules"
                                    :validation-rules="{ checkDatesIntervalRules }"
                                    :validation-messages="{
                    checkDatesIntervalRules: 'La date de début doit être inférieur ou égale à la date de fin.',
                  }"
                                    validation-visibility="live"
                                    format="DD/MM/YYYY"
                                    value-format="YYYY-MM-DD"
                                    v-model="availabilityStartDate"
                                    clearable
                                    placeholder="Sélectionner une date de début"
                                    :label-class="'text-lg font-bold text-gray-950'"
                                />
                            </div>
                                <div class="col flex items-end space-x-4">
                                    <FormKit
                                        type="datepicker"
                                        name="availabilityEndDate"
                                        label="Date de fin"
                                        validation="checkDatesIntervalRules"
                                        :validation-rules="{ checkDatesIntervalRules }"
                                        :validation-messages="{
                        checkDatesIntervalRules: 'La date de fin doit être supérieure ou égale à la date de début.',
                      }"
                                        validation-visibility="live"
                                        format="DD/MM/YYYY"
                                        value-format="YYYY-MM-DD"
                                        v-model="availabilityEndDate"
                                        clearable
                                        :label-class="'text-lg font-bold text-gray-950'"
                                    />
                                    <FormKit
                                        type="button"
                                        label="Filtrer"
                                        :class="{ 'btn-secondary': true, 'btn-block': true }"
                                        @click="filterAvailableDocumentsByExpirationDate"
                                        :disabled="!valid || isLoading"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col  justify-end " >
                            <Button
                                size="small"
                                class="btn btn-primary p-2 ps-2 pe-2"
                                style="margin-top: 0.5em"
                                title="Désactiver la liste des Documents"
                                @click="disableGroupAction(selectedDocuments)"
                            >
                                Désactiver la liste des Documents
                            </Button>
                            <p class='mt-5'>Nombre de ligne sélectionnée(s) : {{ selectedDocuments.length }} Document(s)</p>

                        </div>

                    </div>
                </FormKit>
            </template>
            <div class="card-body pt-0">
                <Column selectionMode="multiple"></Column>
                <Column field="docName" header="Nom du Document" :showFilterMenu="false">
                    <template #filter="{ filterCallback }">
                        <InputText v-model="docNameModel" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Rechercher un document" @keyup.enter="onFilterDt"/>
                    </template>
                    <template #body="{ data }">
                        {{ data.docName }}
                    </template>
                </Column>
                <Column field="productName" header="Nom du produit" :showFilterMenu="false">
                    <template #body="{ data }">
                        {{ data.productName }}
                    </template>
                    <template #filter="{ filterCallback }">
                        <InputText v-model="productNameModel" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Rechercher par produit" @keyup.enter="onFilterDt"/>
                    </template>
                </Column>
                <Column field="productType" header="Type de produit" />
                <Column field="supplierName" header="Fournisseur" :showFilterMenu="false">
                    <template #body="{ data }">
                        {{ data.supplierName }}
                    </template>
                    <template #filter="{ filterCallback }">
                        <FormKit
                            type="taglist"
                            name="supplier"
                            placeholder="Sélectionner un fournisseur"
                            v-model="supplierModel"
                            :options="searchSuppliers"
                            empty-message="Aucun fournisseur trouvé"
                            max="1"
                        />
                    </template>
                </Column>
                <Column field="expirationDate" header="Expiration" dataType="date"/>
            </div>
            <template #empty>Aucun résultat trouvé.</template>
        </DataTable>
</template>
<script setup lang="ts">
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Calendar from 'primevue/calendar';
import AutoComplete from "primevue/autocomplete";
import { ref, onMounted, watch } from "vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { downloadSoldDocumentCsv, fetchDocumentsAvailable } from "@/_services/document/document";
import { deleteDocument } from "@/_services/document/document";
import { Document } from "@/models/product/document/Document";
import swal from "@/_helpers/swal";
import ApiService from "@/_services/api.service";
import moment from "moment/moment";

const isLoading = ref<boolean>(true);
const documents = Array<Document>();
const tableData = ref<Array<Document>>(documents);
const localStorageKey = "selectedDocuments";
const selectedDocuments = ref(Array<Document>());
const availabilityStartDate = ref<string>('');
const availabilityEndDate = ref<string>('');
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const defaultRowsPerPage = 10;
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const currentPage = ref<number>(0);
const docNameModel = ref<string>("");
let supplierModel = ref<string | null>(null);
let productNameModel = ref<string>("");

onMounted(async () => {
    await populateDatatable();
    setLocalStorageRowsPerPage(rows.value);
});

async function populateDatatable() {
    let paramsFilter: any = {
        name: docNameModel.value,
        supplier: supplierModel.value,
        productName: productNameModel.value,
        availabilityStartDate: availabilityStartDate.value,
        availabilityEndDate: availabilityEndDate.value,
    }
    const [loadingDt,totalRecordsDt,  tableDataDt] = await fetchDocumentsAvailable(rows.value, page.value, paramsFilter);
    isLoading.value = loadingDt;
    tableData.value = tableDataDt;
    totalRecords.value = totalRecordsDt;
}

watch([availabilityStartDate, availabilityEndDate],
    ([newAvailabilityStartDate, newAvailabilityEndDate], [prevAvailabilityStartDate, prevAvailabilityEndDate]) => {
        if (
            (newAvailabilityStartDate === '' || newAvailabilityStartDate === undefined) &&
            (newAvailabilityEndDate === '' || newAvailabilityEndDate === undefined) &&
            productNameModel.value === '' &&
            docNameModel.value === ''
        ) {
            clearDtSelectedDocuments();
        }
    }
);

watch(supplierModel, () => {
    onChangeSelectedSupplier();
});

const onChangeSelectedSupplier = async (): Promise<void> => {
    await populateDatatable();
};

const checkDatesIntervalRules = (node: any) => {
    const selectedDate = node.value;
    if (typeof availabilityStartDate.value !== 'undefined' && typeof availabilityEndDate.value !== 'undefined') {
        return moment(availabilityStartDate.value).isSameOrBefore(availabilityEndDate.value);
    }

    return true;
}

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable();
};
const onFilterDt = () => {
    if (docNameModel.value === ''
        && productNameModel.value === ''
        && isAvailabilityStartDateEmpty()
        && isAvailabilityEndDateEmpty()
    ) {
        clearDtSelectedDocuments();
    }

    rows.value = 10;
    page.value = 1;
    populateDatatable();
};

const filters = ref({
    //global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    docName: { value: null, matchMode: FilterMatchMode.IN },
    productName: { value: null, matchMode: FilterMatchMode.IN },
    supplierName: { value: null, matchMode: FilterMatchMode.IN },
    expirationDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
});

function getLocalStorageRowsPerPage() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.rows) {
        return localStorageData.rows;
    }
    return defaultRowsPerPage;
}

function getLocalStorageData() {
    let storageData = localStorage.getItem(localStorageKey);
    if (null !== storageData && "undefined" !== storageData) {
        return JSON.parse(storageData);
    }

    return null;
}

function setLocalStorageRowsPerPage(rowPerPage: number) {
    let storageData = localStorage.getItem(localStorageKey);
    if (null !== storageData) {
        let localStorageObject = JSON.parse(storageData);
        localStorageObject.rows = rowPerPage;
        localStorage.setItem(localStorageKey, JSON.stringify(localStorageObject));
    }
}

function disableGroupAction(selectedDocuments){
    selectedDocuments.length.value <= 0
        ? swal.warning("Veuillez selectionner au moins un document")
        : swal
            .confirm(`Êtes-vous sûr de vouloir désactiver  les (${selectedDocuments.length}) Document(s) ?`)
            .then((result) => {
                if (result.isConfirmed) {
                    disableGroupDocuments(selectedDocuments);
                }else {
                    window.location.reload();
                }
            });
}
async function disableGroupDocuments(selectedDocuments) {
    const uuidArray = getSelectedDocumentUuids(selectedDocuments);


    const dataToSendToApi = {
        documents: uuidArray,
    };

    await ApiService.patchWithoutSlug("disable_product_documents", dataToSendToApi)
        .then(() => {
            swal.info(`Vous venez de désactiver (${selectedDocuments.length}) document(s).`).then(() => {
                window.location.reload();
            });
        })
        .catch(() => {
            swal.error().then(() => {
                window.location.reload();
            });
        });
}

function getSelectedDocumentUuids(selectedDocuments) {
    return selectedDocuments.map((document) => document.uuid);
}

async function searchSuppliers_old({search}) {
    if (!search) return [];
    const fetchSuppliers = await ApiService.get(`suppliers?name=${search || ''}&isActive=true`);
    return fetchSuppliers.data.data.map((val: any) => {
        return {
            label: val.name,
            value: val.uuid
        }
    });
}

async function searchSuppliers({ search, page, hasNextPage }) {
    interface IParams { itemsPerPage: number; page: number; name?: string }
    const params: IParams = {
        itemsPerPage: 5,
        page: page,
        ...(search && { name: search.trim() })
    };

    const { data } = await ApiService.get(`suppliers?isActive=true`, {
        headers: { Accept: 'application/ld+json' },
        params: params,
    });

    const totalSuppliersForDropDown = data.data['hydra:totalItems'];
    const suppliers = data.data['hydra:member'].map((item: {uuid: string, name: string}) => ({
        label: item.name,
        value: item.uuid,
    }));

    const hasItems = suppliers.length > 0;
    if (hasItems && page !== totalSuppliersForDropDown) {
        hasNextPage();
    }

    return suppliers;
}

const filterAvailableDocumentsByExpirationDate = async () => {
    isLoading.value = true;
    try {
        await populateDatatable();
    } catch (error) {
        swal.error("Erreur lors de la recherche par date d'expiration");
    } finally {
        isLoading.value = false;
    }
}

const clearDtSelectedDocuments = () => {
    selectedDocuments.value = [];
};

const isAvailabilityStartDateEmpty = (): boolean => {
    return availabilityStartDate.value === "" || availabilityStartDate.value === undefined;
}

const isAvailabilityEndDateEmpty = (): boolean => {
    return availabilityEndDate.value === "" || availabilityEndDate.value === undefined;
}
</script>